import * as moment from 'moment';

/**
 * Extended-attribute dates are calendar days. Converting via local YYYY-MM-DD avoids UTC day shift
 * when `Date` is JSON-serialized for the API or shown in `mat-datepicker`.
 */
export function toExtendedAttributeCalendarDate(value: unknown): Date | null {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const m = moment(value as any);
    if (!m.isValid()) {
        return null;
    }

    return new Date(m.format('YYYY-MM-DD'));
}
